import React from 'react'
import PropTypes from 'prop-types'

import Box from '@material-ui/core/Box'
import HotkeyButtonWrapper from './HotkeyButtonWrapper'

import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles({
  buttonIcon: {
    '& img': {
      height: '24px'
    }
  },
  buttonText: (styles) => ({
    fontSize: styles.fontSize,
    color: '#1e2552',
    fontWeight: 600,
    fontFamily: 'Montserrat',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    paddingTop: '3px',
    paddingLeft: '8px',
    paddingRight: '8px'
  })
})

export default function HotkeyMenuButton (props) {
  const {
    id,
    width = 4,
    text,
    fontSize = 16,
    icon = 'Miscellaneous',
    onClick,
    onDoubleClick,
    selected = false
  } = props

  const classes = useStyles({ fontSize })

  return (
    <HotkeyButtonWrapper
      width={width}
      accentColor="#1e2552"
      accent="bottom"
      onClick={(event) => onClick(event, id)}
      onDoubleClick={(event) => onDoubleClick(event, id)}
      selected={selected}
    >
      <Box className={classes.buttonIcon} flex={6} display="flex" alignItems="flex-end" justifyContent="center">
        <img src={require(`../../assets/img/icons/hotkeys/light/${icon}.svg`)} />
      </Box>
      <Box className={classes.buttonText} flex={5} display="flex" alignItems="flex-start" justifyContent="center">
        {text}
      </Box>
    </HotkeyButtonWrapper>
  )
}

HotkeyMenuButton.propTypes = {
  id: PropTypes.string.isRequired,
  width: PropTypes.number,
  text: PropTypes.string.isRequired,
  fontSize: PropTypes.number,
  icon: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  onDoubleClick: PropTypes.func.isRequired,
  selected: PropTypes.bool
}
